module.exports = __webpack_public_path__ + "img/7.52ec92af.png";